import React from "react";
import { DeliverablesTabView } from "./components";

export default function DeliverablesTab({ pageStart, selectedMode, informationId }) {
	return <DeliverablesTabView informationId={informationId} pageStart={pageStart} selectedMode={selectedMode} />;
}
